import { Link } from 'react-router-dom'
import MediaImage from './MediaImage'
import { AFFILIATE_REL } from '../lib/affiliate'
import { revealDelay } from '../lib/reveal'
import type { Product } from '../data/content'

export default function ProductCard({
  product,
  compact = false,
  stagger = 0,
  reveal = true,
}: {
  product: Product
  compact?: boolean
  stagger?: number
  reveal?: boolean
}) {
  const inner = (
    <>
      <MediaImage
        src={product.image}
        size="card"
        sizes={compact ? '(min-width: 1024px) 20vw, 50vw' : '(min-width: 768px) 25vw, 50vw'}
        alt={product.name}
        className="aspect-square w-full bg-sand object-cover object-center"
      />
      <span className="text-caps text-ink">{product.name}</span>
      <span className="text-caps text-stone">{product.brand}</span>
      {product.price ? <span className="text-caps text-rose">{product.price}</span> : null}
    </>
  )

  const revealProps = reveal
    ? {
        'data-reveal': true as const,
        style: stagger ? revealDelay((stagger % 5) * 0.07) : undefined,
      }
    : {}

  if (product.href.startsWith('http')) {
    return (
      <a
        href={product.href}
        target="_blank"
        rel={AFFILIATE_REL}
        {...revealProps}
        className={`flex flex-col hover:text-rose ${compact ? 'gap-1.5' : 'gap-2.5'}`}
      >
        {inner}
      </a>
    )
  }

  return (
    <Link
      to={product.href}
      {...revealProps}
      className={`flex flex-col hover:text-rose ${compact ? 'gap-1.5' : 'gap-2.5'}`}
    >
      {inner}
    </Link>
  )
}
